import { AnalogDut, AnalogInput, AnalogOutput, AnalogTemperatureSensor, BoilerAdapter, BoilerCascade, BoilerGroup, Buzzer, CalibrationTable, Command, Comparator, ConditionalOperator, DayTimetable, DigitalDut, Fob, FobButton, GraphPanel, GuardIndicator, GuardZone, HeatingCircuit, HeatingMode, IntervalTimetable, IOExtension, LogicExpression, ModBusDevice, ModBusSignal, Notification, NTCTemperatureCurve, ObjectArrays, OutputAction, Pause, Pump, Pza, RadioDut, RadioModule, RadioSensor, RadioSensor433, RelayControl, Scenario, SensorReading, StopScenario, ThreewayTap, TimeComparator, TimeInterval, TMKey, UIGroup, User, UserRole, WebElement, WeekTimetable, WiredTemperatureSensor, } from 'z3k-config';
import { MQTTTopic } from 'z3k-parser/model/z3k-config/57-mqtt';
export const z3k_key_namespace = {
    //0
    analog_inputs: AnalogInput,
    wired_temperature_sensors: WiredTemperatureSensor,
    guard_zones: GuardZone,
    notifications: Notification,
    users: User,
    //5
    output_actions: OutputAction,
    boiler_adapters: BoilerAdapter,
    radiomodules: RadioModule,
    radiosensors: RadioSensor,
    commands: Command,
    //10
    web_elements: WebElement,
    scenarios: Scenario,
    buzzers: Buzzer,
    guard_indicators: GuardIndicator,
    relay_controls: RelayControl,
    //15
    threeway_taps: ThreewayTap,
    heating_circuits: HeatingCircuit,
    pumps: Pump,
    tm_keys: TMKey,
    user_roles: UserRole,
    //20
    heating_modes: HeatingMode,
    day_timetables: DayTimetable,
    week_timetables: WeekTimetable,
    io_extensions: IOExtension,
    //25
    pzas: Pza,
    boiler_groups: BoilerGroup,
    analog_temperature_sensors: AnalogTemperatureSensor,
    ntc_temperature_curves: NTCTemperatureCurve,
    fobs: Fob,
    //30
    fob_buttons: FobButton,
    radiosensors433: RadioSensor433,
    time_intervals: TimeInterval,
    interval_timetables: IntervalTimetable,
    //35
    analog_duts: AnalogDut,
    calibration_tables: CalibrationTable,
    digital_duts: DigitalDut,
    radio_duts: RadioDut,
    graph_panels: GraphPanel,
    //40
    boiler_cascades: BoilerCascade,
    ui_groups: UIGroup,
    object_arrays: ObjectArrays,
    //45
    pauses: Pause,
    conditional_operators: ConditionalOperator,
    comparators: Comparator,
    logic_expressions: LogicExpression,
    sensor_readings: SensorReading,
    //50
    time_comparators: TimeComparator,
    modbus_devices: ModBusDevice,
    modbus_signals: ModBusSignal,
    analog_outputs: AnalogOutput,
    //55
    stop_scenarios: StopScenario,
    mqtt_topics: MQTTTopic,
};
